module.exports = __webpack_public_path__ + "6f5bf7ef98c46d8c808e4d2bc05b8de3.png";